import { httpClient } from "./httpClient";

type Settings = {
  appURL: string;
  appTitle: string;
  supportEmail: string;
  attestation: string;
  releaseNotes: string;
  appURLSite: string;
  attestationMobile: string;
  userGuideTemplate: string;
};

type Data = {
  settings: Settings;
};

export async function getSettings(): Promise<Settings> {
  try {
    const { data } = await httpClient.get<Data>(`/api/v1/settings`);

    return data.settings;
  } catch (error) {
    throw error;
  }
}

export async function getReportURL(type: string): Promise<string> {
  try {
    const { data } = await httpClient.get<string>(
      `/api/v1/settings/get-report-url/${type}`
    );

    return data;
  } catch (error) {
    throw error;
  }
}
